module.exports = __webpack_public_path__ + "img/emr-text.84c216db.png";